import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderProviderPayment } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderProviderPaymentFragment';

export const removeHomeServiceOrderProviderPayment = async (id: number) => {
  const response = await mutationExecute({
    variables: {
      id,
    },
    mutation: graphql(`
      mutation RemoveHomeServiceOrderProviderPayment($id: Float!) {
        removeHomeServiceOrderProviderPayment(id: $id) {
          ...HomeServiceOrderProviderPaymentFragment
        }
      }
    `),
  });

  return response.data?.removeHomeServiceOrderProviderPayment as HomeServiceOrderProviderPayment;
};
